import { TablesStatus } from 'constants/tables';
import { GameType, ITable, TableStates } from 'types/tables';
import { gameStatus } from 'constants/common';

export const tableMock: ITable = {
  id: '0',
  game_id: '',
  auto_round: false,
  auto_draw: false,
  auto_confirm_result: false,
  betting_time: 0,
  status: TablesStatus.Open,
  roundId: '-',
  dealer: {
    avatar: '',
    name: '',
    nickname: 'Dealer',
    gameId: '',
  },
  tableState: TableStates.TableLoading,
  statusText: gameStatus.Loading,
  round: {
    isFinished: false,
    drawResults: [],
  },
  toastItems: [],
  chatMessages: [],
  game_type: GameType.BAC,
  displaying_drawn_result: 0,
  displaying_win_result: 0,
  rng: false,
};
